export default {
  tooltip: {
    cve_update_date_before_alert:
      '<span>Before the alert was published, the Cyberint score last got updated on: <b>{{date}}</b></span> ' +
      "<span>Changes in a CVE's Cyberint Score could result in the release of additional alerts.</span>",
    cve_update_date_before_alert_last_modified_score:
      '<span>Before the alert was published, the Cyberint score last got updated on: <b>{{date}}</b></span> ' +
      "<span>Changes in a CVE's Cyberint Score could result in the release of additional alerts.</span>"
  },
  configurations: {
    alpha_tooltip:
      'This is an early-stage (alpha) alert and may include false positives. Please share feedbacks with our support team anytime.<contactAdmin> Need to turn it off? Contact your admin.</contactAdmin>'
  }
};
